module.exports = __webpack_public_path__ + "static/media/ic-easy.c6b7f5f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ic-easy.svg
// module id = 635
// module chunks = 8